"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'googleDrive.picker.title': '选择 Google Drive 文件',
    'googleDrive.picker.selectFile': '从 Google Drive 选择文件',
    'googleDrive.picker.selectFiles': '从 Google Drive 选择文件',
    'googleDrive.picker.loading': '正在加载 Google Drive API...',
    'googleDrive.picker.initializing': '正在初始化文件选择器...',
    'googleDrive.picker.notAuthenticated': 'Google Drive 未连接',
    'googleDrive.picker.statusError': '检查 Google Drive 状态失败',
    'googleDrive.picker.filesLoadError': '加载文件失败',
    'googleDrive.picker.checkingAuth': '正在检查身份验证...',
    'googleDrive.picker.authRequired': '请先连接您的 Google Drive 账户',
    'googleDrive.picker.connectAccount': '连接 Google Drive',
    'googleDrive.picker.loadingFiles': '正在加载您的 Google Drive 文件...',
    'googleDrive.picker.noFiles': '未找到文件',
    'googleDrive.picker.noFilesDesc': '您的 Google Drive 似乎是空的',
    'googleDrive.picker.refresh': '刷新',
    'googleDrive.picker.searchPlaceholder': '搜索文件...',
    'googleDrive.picker.filesFound': '找到的文件',
    'googleDrive.picker.initError': '无法初始化Google Drive选择器',
    'googleDrive.picker.loadingError': '无法加载Google Drive API',
    'googleDrive.picker.noAccessToken': '访问令牌不可用',
    'googleDrive.picker.error': 'Google Drive选择器错误',
    'googleDrive.picker.fileSelected': '文件已选择',
    'googleDrive.picker.filesSelected': '文件已选择',
    'googleDrive.picker.authError': 'Google身份验证失败',
    'googleDrive.picker.configError': 'Google配置错误',
    'googleDrive.picker.selectDirectory': '选择Google Drive目录',
    'googleDrive.picker.createError': '打开Google Drive选择器失败',
    'googleDrive.picker.connectFirst': '请先在设置中连接Google Drive',
    'googleDrive.picker.tokenExpired': 'Google Drive访问已过期。请在设置中重新连接您的Google Drive账户。',
    'googleDrive.picker.refreshFailed': '刷新Google Drive访问失败。请在设置中重新连接您的账户。',
};
